<div class="formula-constructor">
  <form [formGroup]="form">
    <h3 class="label">{{ label }}</h3>
    <div class="formula-constructor__methodica">
      <textarea
        [formControlName]="'formulaControl'"
      ></textarea>
      <button class="formula-constructor__check"
              title="Нажмите, чтобы проверить формулу"
              (click)="check()"
      >
        <mat-icon [color]="message()?.code==='Success' ? 'green' : 'red'">check</mat-icon>
      </button>
      @if (message()) {
        <div class="formula-constructor__message" [style]="message()?.code==='Success' ? 'color:green' : 'color:red'">
          <div class="formula-constructor__message-item">
            <span>Формула: </span>
            <div class="formula-constructor__expander"></div>
            <strong>( {{ message()?.replacedFormula }} )</strong>
          </div>
          <div class="formula-constructor__message-item">
            <span>Результат вычисления: </span>
            <div class="formula-constructor__expander"></div>
            <strong>{{ message()?.value ? message()?.value : 'нет результата' }}</strong>
          </div>
          <div class="formula-constructor__message-item">
            <span>Выполнено:</span>
            <div class="formula-constructor__expander"></div>
            @if (message()?.code === "Success") {
              <strong>{{ 'успешно' }}</strong>
            }
            @if (message()?.code === "Error") {
              <strong>{{ 'с ошибкой' }}</strong>
            }</div>
        </div>
      }
      @if(errorCheck()) {
        <div class="formula-constructor__error">
          <strong>Ошибка при проверке формулы. Попробуйте ещё раз</strong>
        </div>
      }
    </div>
  </form>
</div>
